import React from "react";
import type { Campaign } from "../types/Campaign";
import { CAMPAIGN_STATUSES, STATUS_COLORS } from "../utils/campaignStatus";

interface StatusBadgeProps {
  status: Campaign['status'];
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = "" }) => {
  const displayText = CAMPAIGN_STATUSES[status];
  const colorClasses = STATUS_COLORS[status];

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClasses} ${className}`}>
      {displayText}
    </span>
  );
};

export default StatusBadge;
